// ** React Imports
import React, {Fragment, useEffect} from 'react'

// ** Reactstrap Imports
import {
    Row,
    Col,
    Card,
    Input,
    Label,
    CardTitle,
    CardHeader, Button
} from 'reactstrap'

// ** Styles
import '@styles/react/libs/tables/react-dataTable-component.scss'
import { getCompanyPositions } from './thunks'
import { useDispatch } from 'react-redux'
import CompanyPositionsTable from './components/CompanyPositionsTable'

const CompanyPositionsList = () => {

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getCompanyPositions())
    }, []);

    return (
        <Fragment>
            <Card>
                <CardHeader className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                    <CardTitle tag='h4'>Posiciones</CardTitle>
                </CardHeader>
            </Card>
            <Card>
                <CompanyPositionsTable />
            </Card>
        </Fragment>
    )
}

export default CompanyPositionsList
